<template>
  <v-container>
    <v-card>
      <v-card-title class="headline font-weight-bold"
        >Согласие на обработку персональных данных</v-card-title
      >
      <v-card-text>
        <p>
          Настоящее Соглашение является публичной офертой (предложением
          заключить соглашение).
        </p>
        <p>
          Нажимая на активные кнопки пользовательского интерфейса сайта
          <a href="https://up-mind.ru">https://up-mind.ru</a> (далее – «Сайт») с
          целью получения обратной связи (звонка, сообщения, коммерческого
          предложения, кодов регистрации и т.д.) (далее – «онлайн-заявка»), Вы
          считаетесь присоединившимся к Соглашению.
        </p>
        <p>
          При изменении законодательства настоящее Соглашение может подвергаться
          изменениям.
        </p>
        <p>
          Если Вы считаете, что Соглашение или администрация Сайта (далее –
          «Оператор») нарушает Ваши права, сообщите об этом по адресу
          электронной почты: <b>info@up-mind.ru</b>
        </p>

        <h2>1. Общие положения</h2>
        <p>
          Пользователь Сайта – любое лицо, осуществляющее вход на Сайт и
          принявшее условия настоящего Соглашения, независимо от факта
          регистрации и авторизации.
        </p>
        <p>
          Субъект персональных данных, идентифицирующийся по фамилии, имени,
          номеру телефона и адресу электронной почты, при посещении Сайта
          <a href="https://up-mind.ru">https://up-mind.ru</a>, действуя
          свободно, своей волей и в своём интересе, а также подтверждая свою
          дееспособность, предоставляет согласие на обработку своих персональных
          данных Обществу с ограниченной ответственностью «АПМАЙНД+» (ИНН
          7802940442, ОГРН 1237800058352, <b>info@up-mind.ru</b>, +7 (800)
          222-58-25), которому принадлежит Сайт и которое зарегистрировано по
          адресу: 197706, г. Санкт-Петербург, ул. Токарева, д. 15, литера А,
          помещ. 3н, место 1.
        </p>

        <h2>2. Обрабатываемые персональные данные</h2>
        <p>
          Согласие предоставляется на обработку следующих данных:фамилия, имя,
          отчество, дата рождения, контактные данные (телефон, адрес электронной
          почты), данные об использовании курсов (время, активность), IP-адрес,
          cookie-файлы, информация о браузере и устройстве, иная информация,
          предоставляемая Пользователем добровольно.
        </p>
        <p>
          Согласие даётся как с использованием средств автоматизации, так и без
          них. Обработка не затрагивает специальные и биометрические категории
          персональных данных.
        </p>

        <h2>3. Цели обработки</h2>
        <p>Персональные данные обрабатываются для:</p>
        <ul>
          <li>
            идентификации Пользователя и предоставления доступа к материалам и
            курсам;
          </li>
          <li>консультирования и обратной связи по заявкам;</li>
          <li>исполнения договорных обязательств;</li>
          <li>информирования о новых продуктах, акциях и обновлениях;</li>
          <li>
            улучшения качества оказываемых услуг и пользовательского опыта;
          </li>
          <li>проведения аналитики, опросов и маркетинговых исследований;</li>
          <li>обеспечения безопасности и стабильной работы Сайта.</li>
        </ul>

        <h2>4. Действия с персональными данными</h2>
        <p>
          Оператор осуществляет следующие действия: сбор, запись,
          систематизацию, накопление, хранение, уточнение (обновление,
          изменение), извлечение, использование, передачу (в том числе
          предоставление, доступ), обезличивание, блокирование, удаление и
          уничтожение персональных данных.
        </p>

        <h2>5. Передача третьим лицам</h2>
        <p>
          Передача персональных данных может осуществляться исключительно в
          целях, указанных в настоящем Соглашении, следующим категориям
          получателей:
        </p>
        <ul>
          <li>
            операторам фискальных данных и платёжным системам для обработки
            платежей (онлайн-кассы, эквайринг);
          </li>
          <li>
            поставщикам CRM-систем и сервисов технической поддержки (в т.ч.
            Bitrix24, хостинг-провайдеры, сервисы рассылок и аналитики);
          </li>
          <li>
            партнёрам Оператора, участвующим в оказании образовательных и
            консультационных услуг.
          </li>
        </ul>
        <p>
          Передача третьим лицам осуществляется при условии соблюдения ими
          требований законодательства РФ о защите персональных данных.
        </p>

        <h2>6. Срок хранения и порядок отзыва согласия</h2>
        <p>
          Согласие действует бессрочно и может быть отозвано субъектом
          персональных данных путём направления письменного уведомления на адрес
          электронной почты Оператора:
          <a href="mailto:info@up-mind.ru"><b>info@up-mind.ru</b></a
          >.
        </p>
        <p>
          В случае отзыва согласия ООО «АПМАЙНД+» вправе продолжить обработку
          персональных данных при наличии оснований, предусмотренных Федеральным
          законом № 152-ФЗ «О персональных данных».
        </p>
        <p>
          Хранение данных осуществляется до достижения целей обработки либо до
          момента отзыва согласия. После этого данные уничтожаются или
          обезличиваются.
        </p>

        <h2>7. Заключительные положения</h2>
        <p>
          Оператор обязуется соблюдать требования Федерального закона № 152-ФЗ
          «О персональных данных» и иных нормативных актов РФ.Пользователь
          подтверждает, что ознакомлен с Политикой конфиденциальности и
          обработки персональных данных, размещённой на сайте:
          <a href="https://up-mind.ru/privacy">https://up-mind.ru/privacy</a>.
        </p>
        <p>
          Настоящее согласие предоставляется в электронной форме, что в
          соответствии с пунктом 1 статьи 9 Федерального закона № 152-ФЗ
          приравнивается к письменной форме согласия.
        </p>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "AgreementView",
};
</script>

<style scoped>
.v-card {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
}
.v-card__text {
  line-height: 1.6;
}
h2 {
  margin-top: 24px;
  margin-bottom: 12px;
  color: #000000;
}
</style>
